
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class PendriveTypesGrid extends Serenity.EntityGrid<PendriveTypesRow, any> {
        protected getColumnsKey() { return PendriveTypesColumns.columnsKey; }
        protected getDialogType() { return PendriveTypesDialog; }
        protected getIdProperty() { return PendriveTypesRow.idProperty; }
        protected getInsertPermission() { return PendriveTypesRow.insertPermission; }
        protected getLocalTextPrefix() { return PendriveTypesRow.localTextPrefix; }
        protected getService() { return PendriveTypesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}